import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { UncontrolledCollapse } from 'reactstrap';
import { FaGift } from 'react-icons/fa';
import WebListArrowButton from '../etc/button/WebListArrowButton';

const WebPromotionList = ({ list_promotion, handleSelectedFunc }) => {
    const { t } = useTranslation();

    const [isOpened, setIsOpened] = useState(false);

    useEffect(() => {
        if (list_promotion.length > 0) {
            setIsOpened(true);
        }
    }, [list_promotion]);

    return(
        <div className="web-main list-area">
            <div className="card p-2">
                <div className="view view-cascade gradient-card-header r-blue-gradient-rgba narrower px-2 d-flex justify-content-between align-items-center">
                    <span className="d-flex white-text mx-1">
                        <FaGift className="font-lg mr-2" aria-hidden="true" />{t("프로모션", { ns: "promotion" })}
                    </span>
                    <WebListArrowButton toggle_id={'promotionList'} list_array={list_promotion} isOpened={isOpened} />
                </div>
                <div className="px-2">
                    {
                        list_promotion !== undefined && list_promotion !== null && list_promotion.length > 0 ?
                            <UncontrolledCollapse toggler="#promotionList" defaultOpen={true} onEntering={() => setIsOpened(true)} onExiting={() => setIsOpened(false)}>
                                <table className="d-flex flex-column table table-sm table-hover mb-0">
                                    <thead>
                                        <tr className="d-flex">
                                            <th className="area-50">
                                                <b>{t("프로모션_명", { ns: "promotion" })}</b>
                                            </th>
                                            <th className="area-30">
                                                <b>{t("프로모션_기간", { ns: "promotion" })}</b>
                                            </th>
                                            <th className="area-20"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            list_promotion.map(
                                                promotion => (
                                                    <tr key={promotion.promotionSeq} className="d-flex">
                                                        <td className="d-flex align-items-center justify-content-center area-50">
                                                            <div className="text-area">
                                                                <span className="info title hiclass-text" title={promotion.promotionName}>
                                                                    {promotion.promotionName}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td className="d-flex align-items-center justify-content-center area-30">
                                                            <span className="hiclass-num-text" title={promotion.promotionStart_YMD + " ~ " + promotion.promotionEnd_YMD}>{promotion.promotionStart_YMD} ~ {promotion.promotionEnd_YMD}</span>
                                                        </td>
                                                        <td className="d-flex align-items-center justify-content-center area-20">
                                                            <button type="button" className="btn btn-sm btn-outline-primary py-1 px-2 m-0" onClick={() => handleSelectedFunc({selectedFunc:"TOGGLE_MODAL_OPENED", promotionSeq:promotion.promotionSeq})}>
                                                            {t("자세히_보기", { ns: "promotion" })}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )
                                            )
                                        }
                                    </tbody>
                                </table>
                            </UncontrolledCollapse> :
                            <div className="view m-3 text-center grey-text">
                                {t("진행_중인_프로모션_없음", { ns: "promotion" })}
                            </div>
                    }
                </div>
            </div>
        </div>
    );
}
export default WebPromotionList;